import { render, staticRenderFns } from "./HeroSliderSlide.vue?vue&type=template&id=4853d1d0&"
import script from "./HeroSliderSlide.vue?vue&type=script&lang=ts&"
export * from "./HeroSliderSlide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageComponent: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/ImageComponent/index.vue').default,HeroSliderButton: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/HeroSlider/HeroSliderButton.vue').default})
